
import React, { useEffect } from "react"
import TMHBanner from "../../components/TMHBanner/TMHBanner"
import DmcaData from "./data.json"
import "./DMCAPage.scss"
import { useTitle } from 'react-use'
import ReactGA from "react-ga4"

export default function DMCAPage() {
    useTitle("DMCA Disclaimer - The Movie House TV")
    useEffect(() => {
        ReactGA.send("pageview")
    })

    return (
        <TMHBanner classOption="only-gradient policy-page" isLogged={false}>
            <div className="dmcaPage">
                <div className="dmcaPage__header">
                    <h1>{DmcaData.title}</h1>
                    <h5>{DmcaData.subTitle}</h5>
                    {DmcaData.description.map((item, index) => (
                        <p key={`policy-description-${index}`}>{item}</p>
                    ))}
                </div>
                {DmcaData.content.map((text, index) => text ? (
                    <div key={`policy-item-${index}`}>
                        <p>{text}</p>
                    </div>
                ): (<br/>))}
                <nav className="dmcaPage__footer">
                    <a href="/tmh/#/privacy-policy" target="_blank">
                        Privacy policy
                    </a>
                    <a href="/tmh/#/terms-conditions" target="_blank">
                        Terms &#38; conditions
                    </a>
                    <a href="/tmh/#/about" target="_blank">
                        About The Movie House
                    </a>
                </nav>
            </div>
        </TMHBanner>
    )
}
